import { Card, CardBody, Col, Row } from 'reactstrap'
import { H2, H5, H6, ProgressBar } from '../../../../../AbstractElements'
import { monthlyDropdownList, orderOverviewData } from '../../../../../Data/DashboardsData/ECommerceData'
import { TotalEarningCardProp } from '../../../../../Types/DashboardsType'
import { OrderOverviewTitle, TotalRevenue } from '../../../../Constants'
import DropdownWithHeader from '../../DropdownWithHeader'
import InvoicesCard from './InvoicesCard'
import MonthlySaleCard from './MonthlySaleCard'

export default function OrderOverviewMonthlyInvoiceCards({ colClass }: TotalEarningCardProp) {
    return (
        <Row>
            <Col md={7}>
                <Card className="order-overview">
                    <DropdownWithHeader headerClass='pb-0' heading={OrderOverviewTitle} dropDownList={monthlyDropdownList} dropDownClass='icon-dropdown' dropDownIcon={true} />
                    <CardBody>
                        <div className="d-flex">
                            <H2 className="me-2">{'($3,512,201)'}</H2>
                            <H6>{TotalRevenue}</H6>
                        </div>
                        {orderOverviewData.map((item) => (
                            <div className="total-revenue" key={item.id}>
                                <div className="d-flex">
                                    <H5 className="me-2">{item.value}</H5><span>({item.text})</span>
                                </div>
                                <ProgressBar value={item.value} color={item.color} />
                            </div>
                        ))}
                    </CardBody>
                </Card>
            </Col>
            <Col md={5}>
                <Row>
                    <MonthlySaleCard colClass={colClass} />
                    <InvoicesCard colClass={colClass} />
                </Row>
            </Col>
        </Row>
    )
}
